import { PosEnumSelect } from 'src/core/POS/PosSelect';
import { vars } from 'src/core/themes';
import { ContentId } from 'src/utils/constants/contentId';

import { ChartType } from './ChartTypeSelector';
import * as styles from './DataInsightsChart.css';

export const ChartTypeSelectorDropdown = ({
  chartType,
  setChartType,
}: {
  chartType: ChartType;
  setChartType: React.Dispatch<React.SetStateAction<ChartType>>;
}) => {
  return (
    <PosEnumSelect
      valueOptionsContent={{
        pnl: ContentId.ProfitNLoss,
        revenue: ContentId.Revenue,
        sales: ContentId.Sales,
        marketshare: ContentId.MarketShare,
      }}
      value={chartType}
      onChange={(option: ChartType | null) => {
        if (!option) return;
        setChartType(option);
      }}
      variant="rectangle"
      className={styles.chartSelectorDropdown}
    />
  );
};
